import { fragments as customizationAreaListItemFragments } from "./components/CustomizationAreaListItem/graph";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CustomizationAreaListItem from "./components/CustomizationAreaListItem";
import React from "react";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  customizationListAreaItemCard: {
    padding: theme.spacing(2)
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  listItemWrapper: {
    marginBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    marginTop: theme.spacing(1),
    "&:last-child": {
      borderBottomStyle: "none"
    }
  },
  titleWrapper: {
    marginBottom: theme.spacing(0.5)
  }
}));

const CustomizationAreaList = ({ customizationAreas }) => {
  const classes = useStyles();

  if (!customizationAreas || customizationAreas.length === 0) {
    return null;
  }

  return (
    <div>
      <div className={classes.titleWrapper}>
        <Typography variant="h6" color="inherit">
          Customization Area(s)
        </Typography>
      </div>
      <Card className={classes.customizationListAreaItemCard}>
        <ul className={classes.list}>
          {customizationAreas.map((customizationArea, index) => (
            <li className={classes.listItemWrapper} key={customizationArea.id}>
              <CustomizationAreaListItem
                customizationArea={filter(
                  customizationAreaListItemFragments.customizationArea,
                  customizationArea
                )}
                index={`${index + 1}`}
              />
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
};

export default CustomizationAreaList;
